import React from "react";
import "./ProductsByCategory.css";
import { Link } from "react-router-dom";
import { createSlug } from "../../../utils/createSlug";

function ProductsByCategory({ categories }) {
  return (
    <div className="productbycategory-container container">
      <div className="categorytitle-section">
        <h1>
          FILTER BY
          <br />
          <span>CATEGORY</span>
        </h1>
        <div className="plusicon-image">
          <Link to="/productsByBrand">
            <img src="/images/minousicon.png" alt="plus icon" width={120} />
          </Link>
        </div>
      </div>
      <div className="categories-list">
        {categories.map((category, index) => (
          <div key={category.id} className="category-block">
            <h2 className="category-title">{category.name}</h2>
            <div className="products-grid">
              {category.products.map((product, i) => (
                <div key={i} className="product-name">
                  <Link to={`/product/${createSlug(product.name)}`}>
                    {product.name}
                  </Link>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ProductsByCategory;
